/* eslint-disable react-hooks/exhaustive-deps */
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import AppRadio from '../../components/AppRadio';
import PayIcon from '../../components/PayIcon';
import { getFullPicture } from '../../modules/imageHandler';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import Pse from '../../assets/images/pse.png';
import Nequi from '../../assets/images/nequi.png';
import Bancolombia from '../../assets/images/bancolombia.png';
import Gana from '../../assets/images/gana.png';
import Efecty from '../../assets/images/logo-efect.png';
import SisteCredito from '../../assets/images/sistecredito.svg';
import CreditPayment from '../../assets/images/smartphone-online-money.svg';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import AppButton from '../../components/AppButton';
import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import theme from '../../modules/theme';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { SELECTOR_ADDRESS_MAIN } from '../../redux/selectors/addresses';
import { SELECTOR_FULFILLMENT_CURRENT, SELECTOR_FULFILLMENT_SELECTED } from '../../redux/selectors/fulfillments';
import {
  SELECTOR_CREDIT_CARD_SELECTED,
  SELECTOR_CREDIT_CARD_SELECTED_DUES,
  SELECTOR_CREDIT_CARDS,
} from '../../redux/selectors/creditCards';
import { getMyCreditCards, setCreditCardSelected } from '../../redux/actions';
import CreditCardDialog from '../../components/CreditCardDialog';
import { getBanks } from '../../redux/actions';
import { SELECTOR_BANKS } from '../../redux/selectors/banks';
import { addNotification } from '../../redux/actions';
import api from '../../services/api';
import {
  SELECTOR_SHOPPING_CART_ID,
  SELECTOR_SHOPPING_CART_PRODUCTS,
  SELECTOR_SHOPPING_CART_PRODUCTS_COUNT,
} from '../../redux/selectors/shoppingCart';
import { SELECTOR_USER } from '../../redux/selectors/auth';
import ReactPixel from 'react-facebook-pixel';
import { useGA4React } from 'ga-4-react';
import numeral from 'numeral';
import { ApplyDiscount } from './ApplyDiscount';
import { setDiscountId, setDiscount } from '../../redux/actions/discounts';
import { SELECTOR_DISCOUNT_ID } from '../../redux/selectors/discounts';
import { setPaymentMethodRe } from '../../redux/actions/methoPay';
import { setCreditCardSelectedDues } from '../../redux/actions/creditCards';
import { Modal, Card, CardContent, Chip, IconButton, Input } from '@material-ui/core';
import { removeItemInShoppngCart, changeCountItemInShoppingCart, getShoppingCart } from '../../redux/actions';
import { setFulfillmentSelected, setResetFulfillment } from '../../redux/actions/fulfillments';
import DeleteIcon from '@material-ui/icons/Delete';
import { getCroppedPicture } from '../../modules/imageHandler';

const useStylesViewPaymentMethodPSE = makeStyles({
  formControl: {
    width: '100%',
    marginBottom: theme.spacing(1),
  },
});

function ViewPaymentMethodPSE({ PSE, setPSE, visible }) {
  const banks = useSelector(SELECTOR_BANKS);

  const classes = useStylesViewPaymentMethodPSE();
  const dispatch = useDispatch();

  function handleChange(event) {
    setPSE({
      ...PSE,
      [event.target.name]: event.target.value,
    });
  }

  useEffect(() => {
    dispatch(getBanks());
  }, []);

  if (!visible) return <></>

  return (
    <Box ml={3} my={1}>
      <FormControl variant="outlined" className={classes.formControl}>
        <Typography variant="body2">Banco</Typography>
        <Select name="bank" margin="dense" value={PSE.bank} onChange={handleChange} label="Age">
          {banks.map((item) => (
            <MenuItem value={item.bankCode}>{item.bankName}</MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl variant="outlined" className={classes.formControl}>
        <Typography variant="body2">Tipo de identificación</Typography>
        <Select
          labelId="type"
          id="type"
          name="type"
          margin="dense"
          className={classes.textField}
          value={PSE.type}
          onChange={handleChange}
        >
          {['CC', 'CE', 'PPN', 'SSN', 'LIC', 'NIT', 'DNI'].map((value) => (
            <MenuItem value={value} key={value}>
              {value}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl variant="outlined" className={classes.formControl}>
        <Typography variant="body2">Numero de identificación</Typography>
        <TextField
          variant="outlined"
          name="dni"
          value={PSE.dni}
          onChange={handleChange}
          className={classes.textField}
          margin="dense"
        />
      </FormControl>
      <FormControl variant="outlined" className={classes.formControl}>
        <Typography variant="body2">Numero de teléfono</Typography>
        <TextField
          variant="outlined"
          name="cell_phone"
          value={PSE.cell_phone}
          onChange={handleChange}
          className={classes.textField}
          margin="dense"
        />
      </FormControl>
    </Box>
  );
}

function ViewPaymentMethodEfecty({ EFECTY, setEFECTY, visible }) {

  const classes = useStylesViewPaymentMethodPSE();

  function handleChange(event) {
    setEFECTY({
      ...EFECTY,
      [event.target.name]: event.target.value,
    });
  }

  if (!visible) return <></>

  return (
    <Box ml={3} my={1}>
      <FormControl variant="outlined" className={classes.formControl}>
        <Typography variant="body2">Tipo de identificación</Typography>
        <Select
          labelId="type"
          id="type"
          name="type"
          margin="dense"
          className={classes.textField}
          value={EFECTY.type}
          onChange={handleChange}
        >
          {['CC', 'CE', 'PPN', 'SSN', 'LIC', 'NIT', 'DNI'].map((value) => (
            <MenuItem value={value} key={value}>
              {value}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl variant="outlined" className={classes.formControl}>
        <Typography variant="body2">Numero de identificación</Typography>
        <TextField
          variant="outlined"
          name="dni"
          value={EFECTY.dni}
          onChange={handleChange}
          className={classes.textField}
          margin="dense"
        />
      </FormControl>
    </Box>
  );
}

function ModalPagos({ data, visible, oderId }) {

  if (!visible) return <></>

  const handleClose = () => {
    window.open(`/mi-cuenta/mis-pedidos/${oderId}`, '_self')
    // setvisiblePAgos(false)
  }

  return (
    <Modal open={visible} handleClose={handleClose}>
      <Box ml={3} my={1} style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 500,
        padding: 30,
        backgroundColor: 'white',
        textAlign: 'center'
      }}>
        <>
          <span style={{
            position: "absolute",
            right: "10px",
            top: "8px",
            background: "#e7e7e7",
            borderRadius: "30px",
            width: "24px",
            height: "24px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            lineHeight: "1",
            cursor: 'pointer',
          }} onClick={() => handleClose()}>X</span>
          {data.payment_method_type === 'NEQUI' ? (
            <>
              <h3>Ingresa a la app de nequi y acepta el pago</h3>
            </>
          ) : (
            <>
              <h3>Información de pago {data?.banco}</h3>
              <p>Te Pediran estos datos</p>
              <h3>
                <b>Nº de convenio</b>
              </h3>
              <p>{data.codigoproyecto}</p>
              <h3>
                <b>Referencia</b>
              </h3>
              <p>{data.pin}</p>
            </>
          )}
        </>
      </Box>
    </Modal>
  );
}

function ViewPaymentMethodGana({ GANA, setGANA, visible }) {

  const classes = useStylesViewPaymentMethodPSE();

  function handleChange(event) {
    setGANA({
      ...GANA,
      [event.target.name]: event.target.value,
    });
  }


  if (!visible) return <></>

  return (
    <Box ml={3} my={1}>
      <FormControl variant="outlined" className={classes.formControl}>
        <Typography variant="body2">Tipo de identificación</Typography>
        <Select
          labelId="type"
          id="type"
          name="type"
          margin="dense"
          className={classes.textField}
          value={GANA.type}
          onChange={handleChange}
        >
          {['CC', 'CE', 'PPN', 'SSN', 'LIC', 'NIT', 'DNI'].map((value) => (
            <MenuItem value={value} key={value}>
              {value}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl variant="outlined" className={classes.formControl}>
        <Typography variant="body2">Numero de identificación</Typography>
        <TextField
          variant="outlined"
          name="dni"
          value={GANA.dni}
          onChange={handleChange}
          className={classes.textField}
          margin="dense"
        />
      </FormControl>
    </Box>
  );
}

function ViewPaymentMethodSistecredito({ SISTECREDITO, setSISTECREDITO, visible }) {

  const classes = useStylesViewPaymentMethodPSE();

  function handleChange(event) {
    setSISTECREDITO({
      ...SISTECREDITO,
      [event.target.name]: event.target.value,
    });
  }

  if (!visible) return <></>

  return (
    <Box ml={3} my={1}>
      <FormControl variant="outlined" className={classes.formControl}>
        <Typography variant="body2">Tipo de identificación</Typography>
        <Select
          labelId="type"
          id="type"
          name="type"
          margin="dense"
          className={classes.textField}
          value={SISTECREDITO.type}
          onChange={handleChange}
        >
          {['CC', 'CE', 'PPN', 'SSN', 'LIC', 'NIT', 'DNI'].map((value) => (
            <MenuItem value={value} key={value}>
              {value}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl variant="outlined" className={classes.formControl}>
        <Typography variant="body2">Numero de identificación</Typography>
        <TextField
          variant="outlined"
          name="dni"
          value={SISTECREDITO.dni}
          onChange={handleChange}
          className={classes.textField}
          margin="dense"
        />
      </FormControl>
    </Box>
  );
}

function ViewPaymentMethodNequi({ NEQUI, setNEQUI, visible }) {

  const classes = useStylesViewPaymentMethodPSE();

  function handleChange(event) {
    setNEQUI({
      ...NEQUI,
      [event.target.name]: event.target.value,
    });
  }

  if (!visible) return <></>

  return (
    <Box ml={3} my={1}>
      <FormControl variant="outlined" className={classes.formControl}>
        <Typography variant="body2">Numero de teléfono</Typography>
        <TextField
          variant="outlined"
          name="cell_phone"
          value={NEQUI.cell_phone}
          onChange={handleChange}
          className={classes.textField}
          margin="dense"
        />
      </FormControl>
    </Box>
  );
}

const useStylesViewPaymentMethodCreditCards = makeStyles({
  addedButton: {
    fontWeight: 400,
  },
});

function ViewPaymentMethodCreditCards(props) {
  const selected = useSelector(SELECTOR_CREDIT_CARD_SELECTED);
  const selectedDues = useSelector(SELECTOR_CREDIT_CARD_SELECTED_DUES);
  const creditCards = useSelector(SELECTOR_CREDIT_CARDS);

  const [open, setOpen] = useState(false);

  const classes = useStylesViewPaymentMethodCreditCards();
  const dispatch = useDispatch();

  function handleChange(e) {
    dispatch(setCreditCardSelected(Number(e.target.value)));
  }

  function handleChangeDues(e) {
    dispatch(setCreditCardSelectedDues(e.target.value));
  }

  useEffect(() => {
    dispatch(getMyCreditCards());
    return () => {
      dispatch(setCreditCardSelected(0));
    };
  }, []);

  if (!props.visible) return <></>

  return (
    <Box ml={3}>
      <CreditCardDialog open={open} handleClose={() => setOpen(false)} />
      {creditCards.map((card) => (
        <div
          key={card.id}
          style={{
            display: 'flex',
            gap: 10,
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <RadioGroup aria-label="payment-method" name="payment" onChange={handleChange}>
            <FormControlLabel
              checked={selected === card.id}
              value={card.id}
              control={<AppRadio color="default" />}
              label={
                <Box display="flex" alignItems="center">
                  <img
                    width={64}
                    height={40}
                    src={getFullPicture(`logos-tarjetas-de-credito/${card.brand}.png`)}
                    alt={`logos-tarjetas-de-credito/${card.brand}.png`}
                  />
                  {card.masked_number.replaceAll('*', '')}
                </Box>
              }
            />
          </RadioGroup>
          {selected === card.id && (
            <div style={{ width: 80 }}>
              <Typography variant="body2">Cuotas</Typography>
              <Select
                labelId="credit_dues_id"
                id="credit_dues_id"
                name="credit_dues"
                margin="dense"
                style={{
                  width: '100%',
                }}
                className={classes.textField}
                value={selectedDues}
                onChange={handleChangeDues}
              >
                {new Array(36).fill(0).map((_, index) => (
                  <MenuItem value={index + 1} key={`credit_dues_${index}`}>
                    {index + 1}
                  </MenuItem>
                ))}
              </Select>
            </div>
          )}
        </div>
      ))}
      <Button onClick={() => setOpen(true)} color="primary" startIcon={<AddIcon />} className={classes.addedButton}>
        Añadir nueva tarjeta
      </Button>
    </Box>
  );
}

function ViewPaymentMethodCreditBudgets({ data = [], onChange = () => { } }) {
  const [budgetSelected, setBudgetSelected] = useState();

  const classes = useStylesViewPaymentMethodPSE();

  return (
    <Box mt={2}>
      <FormControl variant="outlined" className={classes.formControl}>
        <Typography variant="body2">Centro de costo</Typography>
        <Select
          labelId="company_budget_id"
          id="company_budget_id"
          name="company_budget_id"
          margin="dense"
          placeholder="Seleccionar centro de costo"
          className={classes.textField}
          value={budgetSelected}
          onChange={(e) => {
            setBudgetSelected(e.target.value);
            onChange(e.target.value);
          }}
        >
          {data.map((value) => (
            <MenuItem value={value.company_budget_id} key={`budget_key_${value.id}`}>
              {value.company_budget.cost_center} - {value.company_budget.major_account}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}

const useStyles = makeStyles({
  subtitle: {
    fontSize: '1rem',
    fontWeight: 600,
  },
  addedButton: {
    fontWeight: 400,
  },
  pse: {
    maxWidth: '40px',
    margin: 0,
    maxHeight: '30px',
  },
  formControl: {
    width: '100%',
    marginBottom: theme.spacing(1),
  },
});

const MSG_EMPTY_METHOD = 'Selecciona un método de pago para poder realizar el pedido.';
const MSG_EMPTY_BUDGET = 'Escoge el centro de costo al cual deseas aplicar esta compra.';
const MSG_NO_CREDIT_AVAILABLE =
  'Este pedido excede el presupuesto restante del centro de costo :cost_center, el presupuesto restante es de :available. Reduce el valor de la compra on indícale al administrador  que aumente el presupuesto.';

const useStylesUnavailableProducts = makeStyles({
  productCard: {
    marginBottom: theme.spacing(2),
    border: '1px solid #f5c6cb',
    backgroundColor: '#fff5f5',
  },
  productInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  productImage: {
    width: 80,
    height: 80,
    objectFit: 'cover',
    borderRadius: 8,
  },
  productDetails: {
    flex: 1,
  },
  productActions: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  quantityInput: {
    width: 60,
    textAlign: 'center',
  },
});

function UnavailableProductsManager({ products, onProductUpdate }) {
  const classes = useStylesUnavailableProducts();
  const dispatch = useDispatch();

  const unavailableProducts = products.filter((item) => 
    item.product.status === 'deleted' || 
    item.product.quantity <= 0 || 
    item.quantity > item.product.quantity
  );

  const checkAndResetIfNeeded = (updatedProducts) => {
    // Verificar si ya no hay productos problemáticos después de la actualización
    const stillHasProblems = updatedProducts.some((item) => 
      item.product.status === 'deleted' || 
      item.product.quantity <= 0 || 
      item.quantity > item.product.quantity
    );

    // Si ya no hay productos problemáticos, resetear todo
    if (!stillHasProblems) {
      // Resetear la selección de envío para recalcular costos
      dispatch(setFulfillmentSelected(0));
      dispatch(setResetFulfillment());
      
      // Hacer scroll hacia arriba para mostrar la sección de envío
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 1000);
      
      // Mostrar notificación de éxito
      dispatch(addNotification('¡Perfecto! Productos corregidos. Ahora selecciona tu método de envío.', 'success'));
    }
  };

  const handleRemoveProduct = async (itemId) => {
    await dispatch(removeItemInShoppngCart(itemId));
    const updatedCart = await dispatch(getShoppingCart());
    
    onProductUpdate();
    
    // Mostrar notificación inmediata
    dispatch(addNotification('Producto eliminado', 'info'));
    
    // Verificar si necesita resetear después de un pequeño delay para que se actualice el estado
    setTimeout(() => {
      if (updatedCart && updatedCart.shopping_cart_details) {
        checkAndResetIfNeeded(updatedCart.shopping_cart_details);
      }
    }, 300);
  };

  const handleQuantityChange = async (itemId, newQuantity, maxQuantity) => {
    if (newQuantity > 0 && newQuantity <= maxQuantity) {
      await dispatch(changeCountItemInShoppingCart(itemId, newQuantity));
      const updatedCart = await dispatch(getShoppingCart());
      
      onProductUpdate();
      
      // Mostrar notificación inmediata
      dispatch(addNotification('Cantidad actualizada', 'info'));
      
      // Verificar si necesita resetear después de un pequeño delay
      setTimeout(() => {
        if (updatedCart && updatedCart.shopping_cart_details) {
          checkAndResetIfNeeded(updatedCart.shopping_cart_details);
        }
      }, 300);
    }
  };

  const getStatusMessage = (item) => {
    if (item.product.status === 'deleted') {
      return 'Producto eliminado';
    } else if (item.product.quantity <= 0) {
      return 'Sin stock';
    } else if (item.quantity > item.product.quantity) {
      return `Stock insuficiente (máximo ${item.product.quantity})`;
    }
    return '';
  };

  const getStatusColor = (item) => {
    if (item.product.status === 'deleted' || item.product.quantity <= 0) {
      return 'secondary';
    }
    return 'primary';
  };

  if (unavailableProducts.length === 0) return null;

  return (
    <Box mb={3}>
      <Typography variant="h6" style={{ color: '#721c24', marginBottom: 8 }}>
        Productos con problemas de disponibilidad
      </Typography>
      <Typography variant="body2" style={{ color: '#666', marginBottom: 16 }}>
        Los siguientes productos requieren tu atención. Al eliminarlos o cambiar su cantidad, 
        deberás seleccionar nuevamente tu método de envío ya que el costo puede cambiar.
      </Typography>
      {unavailableProducts.map((item) => (
        <Card key={item.id} className={classes.productCard}>
          <CardContent>
            <div className={classes.productInfo}>
              <img
                src={getCroppedPicture(item.product.main_media?.path, { width: 80, height: 80 })}
                alt={item.product.name}
                className={classes.productImage}
              />
              <div className={classes.productDetails}>
                <Typography variant="body1" style={{ fontWeight: 'bold' }}>
                  {item.product.name}
                </Typography>
                <Typography variant="body2" style={{ color: '#666' }}>
                  Cantidad solicitada: {item.quantity}
                </Typography>
                <Chip 
                  label={getStatusMessage(item)} 
                  color={getStatusColor(item)}
                  size="small"
                  style={{ marginTop: 8 }}
                />
              </div>
              <div className={classes.productActions}>
                {item.product.quantity > 0 && item.quantity > item.product.quantity && (
                  <>
                    <Typography variant="body2">Cantidad:</Typography>
                    <Input
                      type="number"
                      value={item.quantity}
                      onChange={(e) => {
                        const newQuantity = parseInt(e.target.value);
                        if (!isNaN(newQuantity)) {
                          handleQuantityChange(item.id, newQuantity, item.product.quantity);
                        }
                      }}
                      inputProps={{
                        min: 1,
                        max: item.product.quantity,
                        className: classes.quantityInput,
                      }}
                    />
                  </>
                )}
                <IconButton
                  onClick={() => handleRemoveProduct(item.id)}
                  color="secondary"
                  size="small"
                  title="Eliminar producto"
                >
                  <DeleteIcon />
                </IconButton>
              </div>
            </div>
          </CardContent>
        </Card>
      ))}
    </Box>
  );
}

// ViewPaymentMethods.propTypes = {
//   setPaymentMethodVie: PropTypes.,
// };


export function ViewPaymentMethods({ setPaymentMethodVie }) {
  const user = useSelector(SELECTOR_USER);
  const address = useSelector(SELECTOR_ADDRESS_MAIN);
  const shoppingCartId = useSelector(SELECTOR_SHOPPING_CART_ID);
  const fulfillmentId = useSelector(SELECTOR_FULFILLMENT_SELECTED);
  const fulfillment = useSelector(SELECTOR_FULFILLMENT_CURRENT);
  const creditCardsId = useSelector(SELECTOR_CREDIT_CARD_SELECTED);
  const creditCardDues = useSelector(SELECTOR_CREDIT_CARD_SELECTED_DUES);
  const products = useSelector(SELECTOR_SHOPPING_CART_PRODUCTS);
  const productsCount = useSelector(SELECTOR_SHOPPING_CART_PRODUCTS_COUNT);
  const discountId = useSelector(SELECTOR_DISCOUNT_ID);

  const [PSE, setPSE] = useState({
    bank: '',
    type: 'CC',
    dni: '',
    cell_phone: '',
  });
  const [EfectyData, setEfecty] = useState({
    type: 'CC',
    dni: '',
  });
  const [GanaData, setGana] = useState({
    type: 'CC',
    dni: '',
  });
  const [SistecreditoDAta, setSistecredito] = useState({
    type: 'CC',
    dni: '',
  });
  const [NEQUIDATA, setNEQUI] = useState({
    cell_phone: '',
  });
  const [paymentMethod, setPaymentMethod] = useState('');
  const [dataCredit, setDataCredit] = useState({});
  const [disabledPayment, setDisabledPayment] = useState(true);
  const [onSubmitProcess, setOnSubmitProcess] = useState(false);
  const [details, setDetails] = useState({ tax: 0, subTotal: 0 });
  const [userBudgets, setUserBudgets] = useState([]);
  const [noUserBudgets, setNoUserBudgets] = useState(false);
  const [availableBudget, setAvailableBudget] = useState(0);
  const [msgDisablePayment, setMsgDisablePayment] = useState(MSG_EMPTY_METHOD);
  const [selectedCompanyBudget, setSelectedCompanyBudget] = useState({});
  const [paymentData, setPaymentData] = useState([]);
  const [responBank, setResponBank] = useState({});
  const [visiblePAgos, setvisiblePAgos] = useState(false);
  const [oderId, setOrdeId] = useState();
  const [hasUnavailableProducts, setHasUnavailableProducts] = useState(false);


  const namePayment = {
    pse: 'Pse',
    bancolombia: 'Bancolombia',
    credit_card: 'Tarjeta de crédito/débito',
    nequi: 'Nequi',
    efecty: 'Efecty',
    gana: 'Gana',
    sistecredito: '',
  }

  const history = useHistory();
  const classes = useStyles();
  const dispatch = useDispatch();
  const ga = useGA4React();

  const handleProductUpdate = () => {
    // Refrescar los productos del carrito para actualizar las validaciones
    dispatch(getShoppingCart());
    
    // Resetear método de pago ya que el usuario debe revisar todo nuevamente
    setPaymentMethod('');
  };

  function _fetchUserBudgets() {
    api.companiesBudgetsUsers
      .find({ query: { user_id: user.id } })
      .then(({ data, total }) => {
        if (!!total) {
          setUserBudgets(data);
          setDisabledPayment(true);
          setMsgDisablePayment(MSG_EMPTY_BUDGET);
        } else {
          setNoUserBudgets(true);
          setDisabledPayment(false);
        }
      })
      .catch(() => { });
  }

  const getPayment = async () => {
    await api.paymentConf.find({ query: { status: 'active' } }).then((res) => {
      setPaymentData(res.data)
    }).catch((err) => {
      console.log(err.message)
    })
  }

  useEffect(() => {
    getPayment()
  }, [])


  function _fetchMyAvailableBudget(company_budget_id) {
    if (!company_budget_id) {
      setDisabledPayment(true);
      setMsgDisablePayment(MSG_EMPTY_BUDGET);
      return;
    }
    api.companiesBudgetsUsers
      .find({ query: { $client: { searchMyBudget: 'true', company_budget_id } } })
      .then((it) => {
        setSelectedCompanyBudget(it.company_budget);
        setAvailableBudget(it.budget_available);
      })
      .catch(() => { });
  }

  useEffect(() => {
    if (paymentMethod === 'credit' && !noUserBudgets) {
      _fetchUserBudgets();
    }
  }, [paymentMethod]);

  useEffect(() => {
    if (
      userBudgets.length &&
      paymentMethod === 'credit' &&
      availableBudget < details.subTotal + (fulfillment ? fulfillment.price : 0)
    ) {
      setDisabledPayment(true);
      setMsgDisablePayment(
        MSG_NO_CREDIT_AVAILABLE.replace(':cost_center', selectedCompanyBudget.cost_center).replace(
          ':available',
          numeral(availableBudget).format('$ 0,000'),
        ),
      );
    } else if (userBudgets.length && paymentMethod === 'credit') {
      setDisabledPayment(false);
    }
  }, [availableBudget]);

  useEffect(() => {
    const unavailableProducts = products.some((it) => it.product.status === 'deleted' || it.product.quantity <= 0 || it.quantity > it.product.quantity);
    setHasUnavailableProducts(unavailableProducts);

    if (availableBudget) {
      setAvailableBudget(0);
      setSelectedCompanyBudget({});
    }
    if (unavailableProducts) {
      setDisabledPayment(true);
      setMsgDisablePayment('Algunos productos ya no están disponibles o la cantidad solicitada excede el stock disponible. Por favor, revisa tu carrito antes de continuar.');
      return;
    } else if (!address?.id) {
      setDisabledPayment(true);
      return;
    } else if (!fulfillmentId) {
      setDisabledPayment(true);
      return;
    } else if (paymentMethod === '') {
      setDisabledPayment(true);
      setMsgDisablePayment(MSG_EMPTY_METHOD);
      return;
    } else if (paymentMethod === 'credit-card' && !creditCardsId) {
      setDisabledPayment(true);
      setMsgDisablePayment(MSG_EMPTY_METHOD);
      return;
    } else if (paymentMethod === 'pse' && (PSE.bank === '' || PSE.type === '' || PSE.dni === '')) {
      setDisabledPayment(true);
      setMsgDisablePayment(MSG_EMPTY_METHOD);
      return;
    }

    setDisabledPayment(false);
  }, [address?.id, fulfillmentId, paymentMethod, creditCardsId, PSE, products]);

  useEffect(() => {
    setPSE({
      ...PSE,
      cell_phone: user.phone || '',
      dni: user.dni || '',
    });

    if (user.dni) {
      api.searchCreditCompany.find().then((it) => {
        setDataCredit(it.credit);
      });
    }
  }, [user.phone, user.dni]);

  useEffect(() => {
    if (productsCount) {
      const prices = products.map((item) => item.quantity * item.product.price_with_tax);
      const tax = products.map((item) => item.quantity * (item.product.price * (item.product.tax_rule_value / 100)));
      
      // Verificar si hay productos no disponibles o con cantidad insuficiente
      const unavailableProducts = products.some((it) => 
        it.product.status === 'deleted' || 
        it.product.quantity <= 0 || 
        it.quantity > it.product.quantity
      );
      setHasUnavailableProducts(unavailableProducts);
      
      setDetails({
        subTotal: Math.trunc(prices.reduce((acc, current) => acc + current)),
        tax: Math.trunc(tax.reduce((acc, current) => acc + current)),
      });
    }
  }, [products]);

  useEffect(() => {
    if (!disabledPayment) setOnSubmitProcess(false);
  }, [disabledPayment]);

  const handlePay = async () => {
    const unavailableProducts = products.some((it) => it.product.status === 'deleted' || it.product.quantity <= 0 || it.quantity > it.product.quantity);
    
    if (unavailableProducts) {
      dispatch(addNotification('Algunos productos ya no están disponibles o la cantidad solicitada excede el stock disponible. Por favor, revisa tu carrito antes de continuar.', 'error'));
      setDisabledPayment(false);
      return;
    }

    setOnSubmitProcess(true);
    setDisabledPayment(true);

    let gtag_client_id;

    if (window?.gtag) {
      try {
        gtag_client_id = await new Promise((resolve, reject) => {
          window.gtag('get', 'G-5EJ257SNKR', 'client_id', (clientID, error) => {
            if (error) {
              console.error("Error obteniendo gtag_client_id:", error);
              reject(error);
            } else {
              console.log(clientID);
              if (!!clientID) {
                console.log(clientID, 11111);
                resolve(clientID);
              } else {
                console.log(clientID, 2222);
                reject(null);
              }
            }
          });
        });
      } catch (error) {
        console.error('Error obteniendo gtag_client_id:', error);
      }
    }


    switch (paymentMethod.split("-")[0]) {
      case 'credit_card':
        if (!creditCardsId) {
          dispatch(addNotification('Selecciona un tarjeta de credito', 'error'));
          setDisabledPayment(false);
          return;
        }
        try {
          const resp = await api.orders.create({
            shopping_cart_id: shoppingCartId,
            address_id: address.id,
            payment_method: 'online',
            total_shipping_cost: fulfillment?.price || 0,
            ...(gtag_client_id ? { gtag_client_id } : {}),
            ...(discountId ? { discount_id: discountId } : {}),
            fulfillment_company_id: fulfillment.fulfillmentCompany.fulfillment_company_id,
            ...(/^no-/gi.test(fulfillment.service_code)
              ? {}
              : { fulfillment_company_service_code: fulfillment.service_code }),
          });

          const processOrder = await api.processOrderPayments.create({
            order_id: resp.id,
            credit_card_id: creditCardsId,
            dues: creditCardDues || 1,
            payment_with: 'credit_card',
          });

          // Codigos de respuesta segun docs de EPayco
          // let success = [1, 3, 7, 8];
          // if (success.includes(processOrder.payment_status)) {
          //   !!ga &&
          //     ga.gtag('event', 'begin_checkout', {
          //       currency: 'COP',
          //       value: resp.total_price,
          //       items: products.map((product) => ({ item_id: product.product_id, item_name: product.product_name })),
          //     });

          //   ReactPixel.track('InitiateCheckout', {
          //     content_category: 'StartPayment',
          //     content_ids: products.map((item) => item.product_i.toString()),
          //     contents: products.map((item) => ({ id: item.product_id.toString(), quantity: item.quantity })),
          //     currency: 'COP',
          //     num_items: products.length,
          //     value: resp.total_price,
          //   });
          //   dispatch(setDiscountId(0));
          //   dispatch(setDiscount(null));
          // } else {
          history.push(`/mi-cuenta/mis-pedidos/${resp.id}`);
          dispatch(setDiscountId(0));
          dispatch(setDiscount(null));
          dispatch(addNotification(processOrder.response.response, 'error'));
          // }
        } catch (e) {
          dispatch(setDiscountId(0));
          dispatch(setDiscount(null));
          dispatch(addNotification(e.message, 'error'));
        } finally {
          setDisabledPayment(false);
        }
        return;
      case 'pse':
        const resp = await api.orders
          .create({
            shopping_cart_id: shoppingCartId,
            address_id: address.id,
            payment_method: 'online',
            // ...(gtag_client_id ? { gtag_client_id } : {}),
            ...(discountId ? { discount_id: discountId } : {}),
            fulfillment_company_id: fulfillment.fulfillmentCompany.fulfillment_company_id,
            ...(/^no-/gi.test(fulfillment.service_code)
              ? {}
              : { fulfillment_company_service_code: fulfillment.service_code }),
          })
          .catch((error) => {
            dispatch(setDiscountId(0));
            dispatch(setDiscount(null));
            setDisabledPayment(false);
            dispatch(addNotification('No fue posible crear la orden', error.message));
            return;
          });

        if (!resp) {
          dispatch(addNotification('No fue posible crear la orden.', 'error'));
          return;
        }
        const respPSE = await api.processOrderPayments
          .create({
            order_id: resp.id,
            payment_with: 'pse',
            bank_id: PSE.bank,
            doc_type: PSE.type,
            doc_number: PSE.dni,
            cell_phone: PSE.cell_phone,
          })
          .catch((error) => {
            dispatch(setDiscountId(0));
            dispatch(setDiscount(null));
            setDisabledPayment(false);
          });
        if (!respPSE.success) {
          dispatch(addNotification(respPSE.text_response, 'error'));
          setDisabledPayment(false);
          dispatch(setDiscountId(0));
          dispatch(setDiscount(null));
          return;
        }
        setDisabledPayment(false);
        window.open(respPSE.data.urlbanco, '_self');
        ga.gtag('event', 'begin_checkout', {
          currency: 'COP',
          value: resp.total_price,
          items: products.map((product) => ({
            item_id: product.product_id,
            item_name: product.product.name,
          })),
        });

        ReactPixel.track('InitiateCheckout', {
          content_category: 'StartPayment',
          content_ids: products.map((item) => item.product_id.toString()),
          contents: products.map((item) => ({ id: item.product_id.toString(), quantity: item.quantity })),
          currency: 'COP',
          num_items: products.length,
          value: resp.total_price,
        });
        return;
      case 'efecty':
        const respOrdEfct = await api.orders
          .create({
            shopping_cart_id: shoppingCartId,
            address_id: address.id,
            payment_method: 'online',
            // ...(gtag_client_id ? { gtag_client_id } : {}),
            ...(discountId ? { discount_id: discountId } : {}),
            fulfillment_company_id: fulfillment.fulfillmentCompany.fulfillment_company_id,
            ...(/^no-/gi.test(fulfillment.service_code)
              ? {}
              : { fulfillment_company_service_code: fulfillment.service_code }),
          })
          .catch((error) => {
            dispatch(setDiscountId(0));
            dispatch(setDiscount(null));
            setDisabledPayment(false);
            dispatch(addNotification('No fue posible crear la orden', error.message));
            return;
          });

        if (!respOrdEfct) {
          dispatch(addNotification('No fue posible crear la orden.', 'error'));
          return;
        }
        const respEfecty = await api.processOrderPayments
          .create({
            order_id: respOrdEfct.id,
            payment_with: 'efecty',
            doc_type: EfectyData.type,
            doc_number: EfectyData.dni,
          })
          .catch((error) => {
            dispatch(setDiscountId(0));
            dispatch(setDiscount(null));
            setDisabledPayment(false);
          });

        setResponBank(respEfecty)
        setvisiblePAgos(true)
        setOrdeId(respOrdEfct.id)

        setDisabledPayment(false);
        // window.open(respPSE.data.urlbanco, '_self');

        !!ga && ga.gtag('event', 'begin_checkout', {
          currency: 'COP',
          value: respOrdEfct.total_price,
          items: products.map((product) => ({
            item_id: product.product_id,
            item_name: product.product.name,
          })),
        });

        ReactPixel.track('InitiateCheckout', {
          content_category: 'StartPayment',
          content_ids: products.map((item) => item.product_id.toString()),
          contents: products.map((item) => ({ id: item.product_id.toString(), quantity: item.quantity })),
          currency: 'COP',
          num_items: products.length,
          value: respOrdEfct.total_price,
        });
        return;
      case 'gana':
        const respOrde = await api.orders
          .create({
            shopping_cart_id: shoppingCartId,
            address_id: address.id,
            payment_method: 'online',
            // ...(gtag_client_id ? { gtag_client_id } : {}),
            ...(discountId ? { discount_id: discountId } : {}),
            fulfillment_company_id: fulfillment.fulfillmentCompany.fulfillment_company_id,
            ...(/^no-/gi.test(fulfillment.service_code)
              ? {}
              : { fulfillment_company_service_code: fulfillment.service_code }),
          })
          .catch((error) => {
            dispatch(setDiscountId(0));
            dispatch(setDiscount(null));
            setDisabledPayment(false);
            dispatch(addNotification('No fue posible crear la orden', error.message));
            return;
          });

        if (!respOrde) {
          dispatch(addNotification('No fue posible crear la orden.', 'error'));
          return;
        }
        const respGana = await api.processOrderPayments
          .create({
            order_id: respOrde.id,
            payment_with: 'gana',
            doc_type: GanaData.type,
            doc_number: GanaData.dni,
          })
          .catch((error) => {
            dispatch(setDiscountId(0));
            dispatch(setDiscount(null));
            setDisabledPayment(false);
          });

        setResponBank(respGana)
        setvisiblePAgos(true)
        setOrdeId(respOrde.id)

        setDisabledPayment(false);
        // window.open(respPSE.data.urlbanco, '_self');
        ga.gtag('event', 'begin_checkout', {
          currency: 'COP',
          value: respOrde.total_price,
          items: products.map((product) => ({
            item_id: product.product_id,
            item_name: product.product.name,
          })),
        });

        ReactPixel.track('InitiateCheckout', {
          content_category: 'StartPayment',
          content_ids: products.map((item) => item.product_id.toString()),
          contents: products.map((item) => ({ id: item.product_id.toString(), quantity: item.quantity })),
          currency: 'COP',
          num_items: products.length,
          value: respOrde.total_price,
        });
        return;
      case 'sistecredito':
        const respOrdeSiste = await api.orders
          .create({
            shopping_cart_id: shoppingCartId,
            address_id: address.id,
            payment_method: 'online',
            // ...(gtag_client_id ? { gtag_client_id } : {}),
            ...(discountId ? { discount_id: discountId } : {}),
            fulfillment_company_id: fulfillment.fulfillmentCompany.fulfillment_company_id,
            ...(/^no-/gi.test(fulfillment.service_code)
              ? {}
              : { fulfillment_company_service_code: fulfillment.service_code }),
          })
          .catch((error) => {
            dispatch(setDiscountId(0));
            dispatch(setDiscount(null));
            setDisabledPayment(false);
            dispatch(addNotification('No fue posible crear la orden', error.message));
            return;
          });

        if (!respOrdeSiste) {
          dispatch(addNotification('No fue posible crear la orden.', 'error'));
          return;
        }
        const respSistecredito = await api.processOrderPayments
          .create({
            order_id: respOrdeSiste.id,
            payment_with: 'sistecredito',
            doc_type: SistecreditoDAta.type,
            doc_number: SistecreditoDAta.dni,
          })
          .catch((error) => {
            dispatch(setDiscountId(0));
            dispatch(setDiscount(null));
            setDisabledPayment(false);
          });

        window.open(respSistecredito.data.urlToRedirect, '_self')

        setDisabledPayment(false);
        // window.open(respPSE.data.urlbanco, '_self');
        ga.gtag('event', 'begin_checkout', {
          currency: 'COP',
          value: respOrdeSiste.total_price,
          items: products.map((product) => ({
            item_id: product.product_id,
            item_name: product.product.name,
          })),
        });

        ReactPixel.track('InitiateCheckout', {
          content_category: 'StartPayment',
          content_ids: products.map((item) => item.product_id.toString()),
          contents: products.map((item) => ({ id: item.product_id.toString(), quantity: item.quantity })),
          currency: 'COP',
          num_items: products.length,
          value: respOrdeSiste.total_price,
        });
        return;
      case 'bancolombia':
        const respbancolom = await api.orders
          .create({
            shopping_cart_id: shoppingCartId,
            address_id: address.id,
            payment_method: 'online',
            // ...(gtag_client_id ? { gtag_client_id } : {}),
            ...(discountId ? { discount_id: discountId } : {}),
            fulfillment_company_id: fulfillment.fulfillmentCompany.fulfillment_company_id,
            ...(/^no-/gi.test(fulfillment.service_code)
              ? {}
              : { fulfillment_company_service_code: fulfillment.service_code }),
          })
          .catch((error) => {
            dispatch(setDiscountId(0));
            dispatch(setDiscount(null));
            setDisabledPayment(false);
            dispatch(addNotification('No fue posible crear la orden', error.message));
            return;
          });

        if (!respbancolom) {
          dispatch(addNotification('No fue posible crear la orden.', 'error'));
          return;
        }
        const respBancolombia = await api.processOrderPayments
          .create({
            order_id: respbancolom.id,
            payment_with: 'bancolombia',
          })
          .catch((error) => {
            dispatch(setDiscountId(0));
            dispatch(setDiscount(null));
            setDisabledPayment(false);
          });

        setDisabledPayment(false);
        window.open(respBancolombia.payment_method.extra.async_payment_url, "_self")
        ga.gtag('event', 'begin_checkout', {
          currency: 'COP',
          value: respbancolom.total_price,
          items: products.map((product) => ({
            item_id: product.product_id,
            item_name: product.product.name,
          })),
        });

        ReactPixel.track('InitiateCheckout', {
          content_category: 'StartPayment',
          content_ids: products.map((item) => item.product_id.toString()),
          contents: products.map((item) => ({ id: item.product_id.toString(), quantity: item.quantity })),
          currency: 'COP',
          num_items: products.length,
          value: respbancolom.total_price,
        });
        return;
      case 'credit':
        try {
          const resp = await api.orders.create({
            shopping_cart_id: shoppingCartId,
            address_id: address.id,
            payment_method: 'credit',
            // ...(gtag_client_id ? { gtag_client_id } : {}),
            ...(discountId ? { discount_id: discountId } : {}),
            ...(selectedCompanyBudget?.id ? { company_budget_id: selectedCompanyBudget.id } : {}),
            fulfillment_company_id: fulfillment.fulfillmentCompany.fulfillment_company_id,
            ...(/^no-/gi.test(fulfillment.service_code)
              ? {}
              : { fulfillment_company_service_code: fulfillment.service_code }),
          });

          if (resp.id) {
            !!ga &&
              ga.gtag('event', 'begin_checkout', {
                currency: 'COP',
                value: resp.total_price,
                items: products.map((item) => ({
                  item_id: item.product_id,
                  item_name: item.product.name,
                })),
              });

            ReactPixel.track('InitiateCheckout', {
              content_category: 'StartPayment',
              content_ids: products.map((item) => item.product_id.toString()),
              contents: products.map((item) => ({ id: item.product_id.toString(), quantity: item.quantity })),
              currency: 'COP',
              num_items: products.length,
              value: resp.total_price,
            });
            dispatch(setDiscountId(0));
            dispatch(setDiscount(null));
            history.push(`/mi-cuenta/mis-pedidos/${resp.id}`);
          } else {
            dispatch(setDiscountId(0));
            dispatch(setDiscount(null));
            // dispatch(addNotification(processOrder.response.response, 'error'));
          }
        } catch (e) {
          dispatch(setDiscountId(0));
          dispatch(setDiscount(null));
          dispatch(addNotification(e.message, 'error'));
        } finally {
          setDisabledPayment(false);
        }
        return;
      case 'nequi':
        const respOrdernequi = await api.orders
          .create({
            shopping_cart_id: shoppingCartId,
            address_id: address.id,
            payment_method: 'online',
            // ...(gtag_client_id ? { gtag_client_id } : {}),
            ...(discountId ? { discount_id: discountId } : {}),
            fulfillment_company_id: fulfillment.fulfillmentCompany.fulfillment_company_id,
            ...(/^no-/gi.test(fulfillment.service_code)
              ? {}
              : { fulfillment_company_service_code: fulfillment.service_code }),
          })
          .catch((error) => {
            dispatch(setDiscountId(0));
            dispatch(setDiscount(null));
            setDisabledPayment(false);
            dispatch(addNotification('No fue posible crear la orden', error.message));
            return;
          });

        if (!respOrdernequi) {
          dispatch(addNotification('No fue posible crear la orden.', 'error'));
          return;
        }
        const respNequi = await api.processOrderPayments
          .create({
            order_id: respOrdernequi.id,
            payment_with: 'nequi',
            cell_phone: NEQUIDATA.cell_phone,
          })
          .catch((error) => {
            dispatch(setDiscountId(0));
            dispatch(setDiscount(null));
            setDisabledPayment(false);
          });

        setResponBank(respNequi)
        setvisiblePAgos(true)
        setOrdeId(respOrdernequi.id)


        ga.gtag('event', 'begin_checkout', {
          currency: 'COP',
          value: respOrdernequi.total_price,
          items: products.map((product) => ({
            item_id: product.product_id,
            item_name: product.product.name,
          })),
        });

        ReactPixel.track('InitiateCheckout', {
          content_category: 'StartPayment',
          content_ids: products.map((item) => item.product_id.toString()),
          contents: products.map((item) => ({ id: item.product_id.toString(), quantity: item.quantity })),
          currency: 'COP',
          num_items: products.length,
          value: respOrdernequi.total_price,
        });
        return;
      default:
        setDisabledPayment(false);
        return;
    }
  };

  const handlePaymentMethodChange = (e) => {
    const data = e.target.value.split("-");
    // console.log("data", data, data[0], data[1])
    dispatch(setPaymentMethodRe(data[0]));
    setPaymentMethod(e.target.value);
  };

  const iconos = {
    pse: <img src={Pse} alt="PSE" className={classes.pse} />,
    bancolombia: <img src={Bancolombia} alt="Bancolombia" className={classes.pse} />,
    credit_card: <PayIcon />,
    nequi: <img src={Nequi} alt="Nequi" className={classes.pse} />,
    efecty: <img src={Efecty} alt="Efecty" className={classes.pse} />,
    gana: <img src={Gana} alt="Gana" className={classes.pse} />,
    sistecredito: <img style={{ maxWidth: 150 }} src={SisteCredito} alt="SisteCredito" />,
  }

  const PaymentMethods = {
    credit_card: ViewPaymentMethodCreditCards,
    pse: ViewPaymentMethodPSE,
    efecty: ViewPaymentMethodEfecty,
    gana: ViewPaymentMethodGana,
    sistecredito: ViewPaymentMethodSistecredito,
    nequi: ViewPaymentMethodNequi,
  }

  return (
    <Box my={3} px={4}>
      {visiblePAgos && (
        <ModalPagos data={responBank} visible={visiblePAgos} oderId={oderId} />
      )}
      <ApplyDiscount />
      <UnavailableProductsManager 
        products={products} 
        onProductUpdate={handleProductUpdate}
      />
      <Typography className={classes.subtitle} color="textPrimary">
        Método de pago
      </Typography>
      <RadioGroup aria-label="payment-method" name="payment" value={paymentMethod} onChange={handlePaymentMethodChange}>
        {paymentData?.map((it) => {
          const Component = PaymentMethods?.[it.paymment_method] ?? (() => <></>)
          return (
            <>
              <FormControlLabel
                value={`${it?.paymment_method}-${it?.gateway}`}
                control={<AppRadio color="default" />}
                label={
                  <Box display="flex" alignItems="center">
                    <Box clone mr={1}>
                      {iconos[it?.paymment_method]}
                    </Box>
                    {namePayment[it?.paymment_method]}
                  </Box>
                }
              />
              {
                <Component
                  NEQUI={NEQUIDATA}
                  setNEQUI={setNEQUI}
                  SISTECREDITO={SistecreditoDAta}
                  setSISTECREDITO={setSistecredito}
                  GANA={GanaData} setGANA={setGana}
                  EFECTY={EfectyData}
                  setEFECTY={setEfecty}
                  PSE={PSE}
                  setPSE={setPSE}
                  visible={paymentMethod.split("-")[0] === it.paymment_method}
                />
              }
              {/* {paymentMethod.split("-")[0] === 'credit_card' && it?.paymment_method === 'credit_card' && <ViewPaymentMethodCreditCards />} */}
            </>
          )
        }
        )}
        {/* <FormControlLabel
          value="credit-card"
          control={<AppRadio color="default" />}
          label={
            <Box display="flex" alignItems="center">
              <Box clone mr={1}>
                <PayIcon />
              </Box>
              Tarjeta de crédito/débito
            </Box>
          }
        /> */}
        {/* {paymentMethod === 'credit_card' && <ViewPaymentMethodCreditCards />} */}
        {/* <FormControlLabel
          value="pse"
          control={<AppRadio color="default" />}
          label={
            <Box display="flex" alignItems="center">
              <img src={Pse} alt="PSE" className={classes.pse} />
              pse
            </Box>
          }
        /> */}
        {/* {paymentMethod.split("-")[0] === 'pse' && <ViewPaymentMethodPSE PSE={PSE} setPSE={setPSE} />} */}
        {/* {(dataCredit.credit === 'true' && dataCredit.available_credit < details.subTotal + (fulfillment ? fulfillment.price : 0) && (dataCredit.override_credit === 'false')) && (
          <Box mb={2} mt={2} display="flex" justifyContent="center">
            <Typography
              variant={'caption'}
              style={{
                color: '#d6bb33',
                background: '#f8f0d7',
                padding: 2,
                textAlign: 'center',
                fontWeight: 'normal',
                border: '1px solid #d6bb33',
                borderRadius: 5,
              }}
            >
              El monto del pedido excede el cupo máximo de ${numeral(dataCredit.available_credit).format('0,0')} para el pago a crédito
            </Typography>
          </Box>
        )} */}
        {dataCredit.credit === 'true' && (
          <>
            <FormControlLabel
              value="credit"
              // disabled={dataCredit.available_credit === 0 || (dataCredit.available_credit < details.subTotal + (fulfillment ? fulfillment.price : 0) && dataCredit.override_credit === "false")}
              control={<AppRadio color="default" />}
              label={
                <>
                  <Box display="flex" alignItems="center">
                    <Box clone px={1}>
                      <img src={CreditPayment} alt="CreditPayment" className={classes.pse} />
                    </Box>
                    <Box>
                      Pago a crédito
                      <Box>
                        <Typography variant="caption">
                          Disponible {numeral(dataCredit.available_credit).format('$ 0,000')}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </>
              }
            />
            {paymentMethod === 'credit' && (
              <Box>
                <p>El precio de los productos puede variar con este metodo de pago</p>
              </Box>
            )}
          </>
        )}
      </RadioGroup>

      {!!userBudgets.length && paymentMethod === 'credit' && (
        <ViewPaymentMethodCreditBudgets onChange={_fetchMyAvailableBudget} data={userBudgets} />
      )}
      {hasUnavailableProducts && (
        <Box mt={2}>
          <div
            style={{
              color: '#721c24',
              background: '#f8d7da',
              padding: 20,
              textAlign: 'center',
              fontWeight: 'normal',
              border: '1px solid #f5c6cb',
              borderRadius: 5,
            }}
          >
            Revisa los productos mostrados arriba y elimínalos o ajusta su cantidad. Después deberás seleccionar nuevamente tu método de envío y pago para continuar.
          </div>
        </Box>
      )}
      {disabledPayment && !onSubmitProcess && !hasUnavailableProducts && (
        <Box mt={2}>
          <div
            style={{
              color: '#721c24',
              background: '#f8d7da',
              padding: 20,
              textAlign: 'center',
              fontWeight: 'normal',
              border: '1px solid #f5c6cb',
              borderRadius: 5,
            }}
          >
            {msgDisablePayment}
          </div>
        </Box>
      )}
      <Box display="flex" mt={2} justifyContent="flex-end">
        <AppButton
          round
          disableElevation
          color="secondary"
          variant="contained"
          onClick={handlePay}
          {...(disabledPayment || details.subTotal < 80000 || hasUnavailableProducts ? { disabled: true } : {})}
        >
          Pagar
        </AppButton>
      </Box>
      {details.subTotal < 80000 && (
        <div
          style={{
            marginTop: 15,
            padding: '12px 16px',
            backgroundColor: '#fff2f0',
            border: '1px solid #ffccc7',
            borderRadius: '4px',
          }}
        >
          <p
            style={{
              color: '#f5222d',
              fontSize: '14px',
              fontWeight: 'bold',
              margin: 0,
            }}
          >
            ⚠️ El monto mínimo de compra en nuestra página es de $80.000 para envíos a todo
            Colombia.
          </p>
        </div>
      )}
    </Box>
  );
}
